import IconButton from '@mui/material/IconButton';
import React from 'react';

import Icon from '../icon/Icon';
import type { IconType } from '../icon/types';

type ShareButtonProps = {
  icon: IconType;
  onClick: () => void;
  ariaLabel?: string;
};

const ShareButton: React.FC<ShareButtonProps> = ({
  icon,
  onClick,
  ariaLabel,
}) => (
  <IconButton
    aria-label={ariaLabel}
    onClick={onClick}
    sx={{
      border: '1px solid #dfe5e8',
      boxShadow: '0 2px 6px 0 rgba(124, 139, 155, 0.1)',
    }}
  >
    <Icon icon={icon} color="#000" size={24} />
  </IconButton>
);

export default ShareButton;
